import React from "react";
import { Upload, message } from "antd";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";

import "./UploadPhoto.css";
import ImgCrop from "antd-img-crop";

export const UploadPhoto = ({ imageUrl, saveImage }) => {
    function beforeUpload(file, fileList) {
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
            message.error("You can only upload JPG/PNG file!");
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error("Image must smaller than 2MB!");
        }
        if (isJpgOrPng && isLt2M) {
            saveImage(file);
            return true;
        }
        return false;
    }
    return (
        <ImgCrop grid rotate>
            <Upload
                name="avatar"
                listType="picture"
                showUploadList={false}
                beforeUpload={beforeUpload}
            >
                {imageUrl ? (
                    <img
                        src={imageUrl}
                        alt="avatar"
                        style={{ maxWidth: "250px", minWidth: "250px" }}
                    />
                ) : (
                    <div className="uploadButtonAnt">
                        <PlusOutlined
                            style={{ display: "flex", justifyContent: "center" }}
                        />
                        <div style={{ marginTop: 8 }}>Upload Photo</div>
                    </div>
                )}
            </Upload>
        </ImgCrop>
    );
};
